import { render } from "./contentManagement.vue?vue&type=template&id=0f8c4190"
import script from "./contentManagement.vue?vue&type=script&lang=js"
export * from "./contentManagement.vue?vue&type=script&lang=js"

import "./contentManagement.vue?vue&type=style&index=0&id=0f8c4190&lang=less"
script.render = render

export default script